import * as React from 'react';

import { StyledLabel, StyledTagsList } from './styles';
import Tag from './Tag';

export interface TagState {
	label: string;
	isActive: boolean;
}

interface TagsListProps {
	tags: TagState[];
	onTagToggle: (index: number) => void;
}

const TagsList = ({ tags, onTagToggle }: TagsListProps) => (
	<>
		<StyledLabel value="messages.select_your_tags" />
		<StyledTagsList>
			{tags.map(({ label, isActive }, index) => (
				<li key={index}>
					<Tag
						index={index}
						label={label}
						isActive={isActive}
						onToggle={() => onTagToggle(index)}
					/>
				</li>
			))}
		</StyledTagsList>
	</>
);

export default TagsList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/Search/TagsList/index.tsx